import * as React from 'react';
import { Radio as MuiRadio, RadioProps as MuiRadioProps } from '@mui/material';

export type RadioProps = MuiRadioProps;

export const Radio: React.FunctionComponent<RadioProps> = function ({
    color = 'primary',
    ...props
}) {
    return (
        <MuiRadio
            {...props}
            color={color}
            data-testid="radio"
        />
    );
};
